/**
 * Запросы к `/api/supervisor/*` (BE-10).
 * Все мутирующие — требуют Bearer + RBAC по КАТО (см. CurrentUser).
 */
import { api } from './api';

export interface NationalityWriteRequest {
  kato: number;
  year: number;
  kazakhs?: number | null;
  russians?: number | null;
  others?: number | null;
}

export interface NationalityResponse {
  id: number;
  kato: number;
  year: number | null;
  kazakhs: number | null;
  russians: number | null;
  others: number | null;
}

export const createNationality = async (
  body: NationalityWriteRequest,
): Promise<NationalityResponse> => {
  const response = await api.post<NationalityResponse>(
    '/supervisor/population-nationality',
    body,
  );
  return response.data;
};

export const updateNationality = async (
  id: number,
  body: NationalityWriteRequest,
): Promise<NationalityResponse> => {
  const response = await api.put<NationalityResponse>(
    `/supervisor/population-nationality/${id}`,
    body,
  );
  return response.data;
};

export const deleteNationality = async (id: number): Promise<void> => {
  await api.delete(`/supervisor/population-nationality/${id}`);
};
